import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OuraCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const code = params.get('code');
    const state = params.get('state');
    if (params.get('error') || !code || !state) {
      toast.error('Oura connection was cancelled.');
      navigate('/dashboard', { replace: true });
      return;
    }
    axios
      .post(`${API}/oura/callback`, { code, state }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('sage_token')}` },
      })
      .then(() => toast.success('Oura connected.'))
      .catch((e) => toast.error(e.response?.data?.detail || 'Could not connect Oura.'))
      .finally(() => navigate('/dashboard', { replace: true }));
  }, [params, navigate]);

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center" data-testid="oura-callback-page">
      <div className="flex items-center gap-3 text-zinc-400 text-sm">
        <Loader2 className="w-4 h-4 animate-spin" /> Connecting your Oura ring…
      </div>
    </div>
  );
}
